import { RandomGenerator } from "../test-utils";
var AccountInfoBuilder = /** @class */ (function () {
    function AccountInfoBuilder() {
        this.accountInfo = {
            accountId: RandomGenerator.id(),
            accountImageUrl: RandomGenerator.randomString(),
            accountName: RandomGenerator.randomString(),
        };
    }
    AccountInfoBuilder.prototype.withAccountId = function (accountId) {
        this.accountInfo.accountId = accountId;
        return this;
    };
    AccountInfoBuilder.prototype.withAccountImageUrl = function (accountImageUrl) {
        this.accountInfo.accountImageUrl = accountImageUrl;
        return this;
    };
    AccountInfoBuilder.prototype.withAccountName = function (accountName) {
        this.accountInfo.accountName = accountName;
        return this;
    };
    AccountInfoBuilder.prototype.withParentAccount = function (parentAccount) {
        this.accountInfo.parentAccount = parentAccount;
        return this;
    };
    AccountInfoBuilder.prototype.withSlug = function (slug) {
        this.accountInfo.slug = slug;
        return this;
    };
    AccountInfoBuilder.prototype.build = function () {
        return this.accountInfo;
    };
    return AccountInfoBuilder;
}());
export { AccountInfoBuilder };
//# sourceMappingURL=account-Info.builder.js.map